import React, {useEffect} from "react";
import "react-datepicker/dist/react-datepicker.css";
import AddNewContactModal from "../../components/customerMaster/AddNewContactModal";
import DeleteModal from "../../components/common/DeleteModal";
import FetchData from "../../providers/dataProvider";
import CustomerDetails from "../../components/customerMaster/CustomerDetails";
import useForm from "../customerMaster/useForm";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import AdditionalContact from "../../components/customerMaster/AdditionalContact";
import CustomerDocuments from "../../components/customerMaster/CustomerDocuments";
import ErrorMessage from "../../components/common/ErrorMessage";
import { checknull } from "../../utils/Validate";
import ViewCustomer from "./ViewCustomer";

const AddNewCustomer = () => {
  const { data: countrydata } = FetchData("country");
  const { data: designationdata } = FetchData("designation");
  const { data: CustomerTypeData } = FetchData("customertype");
  const { data: distributorTypeData } = FetchData("distributor");
  const { data: departmentdata } = FetchData("department");
  const { data: documentList } = FetchData("distributorDocuments");
  const { data: salesEngineer } = FetchData("userprofile");

  const {
    selectedOptions,
    setSelectedOption,
    handleFormChange,
    formValues,
    setFormValues,
    country,
    handleCountryChange,
    customertype,
    distributortype,
    setDistributortype,
    handleDistributorType,
    handleSalesEngChange,
    handleCustomerType,
    handleFormSubmit,
    formErrors,
    createMsg,
    show,
    setShow,
    setContactShow,
    contactShow,
    contact,
    setConDesignation,
    setConDepartment,
    contactError,
    handleContactChange,
    contacttemp,
    setContactTemp,
    handleConDepChange,
    condepartment,
    handleConDesChange,
    condesignation,
    handleContactSubmit,
    deleteContact,
    EditContact,
    clearFormValues,
    setCountry,
    setSalesEngineerData,
    salesEngineerData,
    errorShow,
    ErrorDoneClick,
    formError,
    handleDocumentChange,
    errors,
    removeAttachedFile,
    handleAttachmentDate,
    SuccessDoneClick,
    docError,
    setDocError,
    disabled,
    AdditionalContactClose,
    customerStatusData,
    setCustomerStatusData,
    handleStatusChange,
    setFormErrors,
    setContactError
  } = useForm(designationdata);
 
  useEffect(()=>{
    const userProfile = JSON.parse(localStorage.getItem("userProfile"));

      if(userProfile?.userType===2)
      {
        setFormValues({
          ...formValues,
          countryId: distributorTypeData?.find(item=>item?.id===userProfile?.userCompanyId)?.countryId,
        });
      }
  },[distributorTypeData])

      useEffect(() => {
      window.dispatchEvent(
        new CustomEvent("pathfinderHeaderMetaChange", {
          detail: {
            pathname: location.pathname,
            title: formValues?.id
              ? `Customer : ${formValues?.customerName}`
              : "New Customer",
            backTarget: {
              pathname: "/customer-master",
            },
          },
        })
      );
    
      return () => {
        window.dispatchEvent(
          new CustomEvent("pathfinderHeaderMetaChange", {
            detail: {
              pathname: location.pathname,
              clear: true,
            },
          })
        );
      };
    }, [
      location.pathname,
      formValues?.id,
      formValues?.customerName,
    ]);

  return (
    <div className="container-fluid add-new-customer-sec">
      <section className="customer-add-sec">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            {/* <!-- Customer Details--> */}
            <CustomerDetails
              setSelectedOption={setSelectedOption}
              selectedOptions={selectedOptions}
              handleFormChange={handleFormChange}
              formValues={formValues}
              handleFormSubmit={handleFormSubmit}
              countrydata={countrydata}
              CustomerTypeData={CustomerTypeData}
              designationdata={designationdata}
              setDistributortype={setDistributortype}
              distributortype={distributortype}
              distributorTypeData={distributorTypeData}
              handleDistributorType={handleDistributorType}
              formErrors={formErrors}
              handleSalesEngChange={handleSalesEngChange}
              handleCountryChange={handleCountryChange}
              handleCustomerType={handleCustomerType}
              customertype={customertype}
              country={country}
              setCountry={setCountry}
              salesEngineerData={salesEngineerData}
              setSalesEngineerData={setSalesEngineerData}
              salesEngineer={salesEngineer}
              customerStatusData={customerStatusData}
              setCustomerStatusData={setCustomerStatusData}
              handleStatusChange={handleStatusChange}
              setFormValues={setFormValues}
              clearFormValues={clearFormValues}
              setFormErrors={setFormErrors}
              setContactShow={setContactShow}
            />
          </div>
        </div>
      </section>

      {/*  <!-- addNewContactModal--> */}
      <AddNewContactModal
        setContactShow={setContactShow}
        contactShow={contactShow}
        handleContactChange={handleContactChange}
        contacttemp={contacttemp}
        setContactTemp={setContactTemp}
        departmentdata={departmentdata}
        designationdata={designationdata}
        handleConDepChange={handleConDepChange}
        condepartment={condepartment}
        handleConDesChange={handleConDesChange}
        condesignation={condesignation}
        handleContactSubmit={handleContactSubmit}
        setConDesignation={setConDesignation}
        setConDepartment={setConDepartment}
        contactError={contactError}
        AdditionalContactClose={AdditionalContactClose}
        setContactError={setContactError}
      />

      <ErrorMessage
        Show={errorShow?.show}
        errorMessage={errorShow?.errorMessage}
        ErrorDoneClick={ErrorDoneClick}
      />
      {/* <!-- deleteModal--> */}
      <DeleteModal />
      {/* <!-- saveSuccessModal--> */}
      <SaveSuccessModel
        show={show}
        createMsg={createMsg}
        setShow={setShow}
        SuccessDoneClick={SuccessDoneClick}
      />

      {/* creditLimitRequestModal  */}
      {/* <CreditLimitRequestModal /> */}
    </div>
  );
};

export default AddNewCustomer;
